import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import '../node_modules/font-awesome/css/font-awesome.min.css'
import '../node_modules/animate.css/animate.min.css'
import './css/bulma.css';
import './css/index.css';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/